import { atom, selector } from "recoil"
import { ActionType } from "../../../constants/enums"

export const rtmpStreamsAtom = atom<{ uid: string }[]>({
  key: "rtmpStreamsAtom",
  default: []
})

export const rtmpStreamsSelector = selector({
  key: "rtmpStreamsSelector",
  get: ({ get }) => get(rtmpStreamsAtom),
  set: ({ get, set }, { action, payload }) => {
    if (action === ActionType.ADD) {
      // check if stream id is already added
      const streams = get(rtmpStreamsAtom)
      if (streams.find(value => value.uid === payload.uid)) {
        // append data if already present
        set(rtmpStreamsAtom, prev =>
          prev.map(value => {
            if (value.uid === payload.uid) {
              return { ...value, ...payload }
            }
            return value
          })
        )
      } else {
        // If not present, append into array
        set(rtmpStreamsAtom, prev => [...prev, payload])
      }
    }

    // Handle Delete Action
    if (action === ActionType.DELETE) {
      set(rtmpStreamsAtom, prev =>
        prev.filter(value => value.uid !== payload.uid)
      )
    }

    if (action === ActionType.RESET) {
      set(rtmpStreamsAtom, [])
    }
  }
})
